// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2370":"98390192","2654":"b9619d2a","3625":"ca23e6ff","5787":"523c3cfa","8464":"191e096c"}[chunkId] + ".chunk.css";
};